import React, { useState, useEffect } from "react";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import UserDetailsModal from "./UserDetailsModal ";
import BottomTray from "../Trays/BottomTray";
import ManageMembers from "../Trays/ManageMembers";

const InvitedMembersList = ({
  listName,
  userId,
  listId,
  componentName,
  BackgroundOnSvg,
  closeOtherDropdown,
  isOpen,
  setIsOpen,
}) => {
  const [memberDetails, setMemberDetails] = useState([]);
  const [friendsCount, setFriendsCount] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!userId || !listName) return;

    // Real-time listener for members subcollection
    const membersRef = collection(
      db,
      "users",
      userId,
      "shoppingList",
      listName,
      "members"
    );

    const unsubscribe = onSnapshot(
      membersRef,
      async (snapshot) => {
        try {
          const memberIds = snapshot.docs.map((doc) => ({
            id: doc.id,
            role: doc.data().role,
          }));

          // Fetch user documents for all members
          const members = await Promise.all(
            memberIds.map(async (member) => {
              const userDocRef = doc(db, "users", member.id);
              const userDoc = await getDoc(userDocRef);
              const userDocData = userDoc.data();
              // Ensure user exists in Stream Chat
              // if (client) {
              //   try {

              //     await client.upsertUser({
              //       id: member.id,
              //       name: userDocData?.userName || 'Unknown',
              //       image: userDocData?.photo ?? `https://ui-avatars.com/api/?name=${userDocData?.userName}`,
              //       email: userDocData?.email
              //     });
              //   } catch (error) {

              //     console.error(`Error creating user ${member.id} on Stream:`, error);
              //   }
              // }
              return {
                ...userDoc.data(),
                role: member.role,
                id: member.id,
              };
            })
          );
          const userDocRef = doc(db, "users", userId);
          const userDoc = await getDoc(userDocRef);
          const userDocData = userDoc.data();
          const myData = {
            ...userDocData,
            role: "Owner",
            id: userId,
          };
          setMemberDetails([myData, ...members]);
          // setMemberDetails(members);
          setFriendsCount(members.length);
        } catch (error) {
          console.error("Error fetching member details:", error);
        }
      },
      (error) => {
        console.error("Error listening to members subcollection:", error);
      }
    );

    // Cleanup on unmount
    return () => unsubscribe();
  }, [listName, userId]);

  const handleUserClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      {componentName === "SingleChat" &&
        (friendsCount && friendsCount > 0 ? (
          <div
            className="d-flex align-items-center"
            onClick={(e) => {
              if (isSmallScreen) {
                setIsOpen(true);
              } else {
                e.stopPropagation();
                handleUserClick();
              }
            }}
            style={{
              cursor: "pointer",
              fontFamily: "Inter",
              fontWeight: 400,
              fontStyle: "italic",
              fontSize: isSmallScreen ? "12px" : "15px",
              lineHeight: "108%",
              letterSpacing: "0%",
              color: "#667085",
            }}
          >
            {memberDetails
              .filter((member) => member.id !== userId)
              .slice(0, 2)
              .map((member, index, arr) => (
                <span
                  key={member.id}
                  style={{ borderBottom: "1px solid #667085" }}
                >
                  {member.userName
                    ? `${member.userName.split(" ")[0]}`
                    : "Unknown"}
                  {index < arr.length - 1 && ","}
                  &nbsp;
                </span>
              ))}
            {friendsCount > 2 && (
              <span style={{ borderBottom: "1px solid #667085" }}>
                + {friendsCount - 2} more
              </span>
            )}
          </div>
        ) : (
          <div
            style={{
              cursor: "pointer",
              fontFamily: "Inter",
              fontWeight: 400,
              fontStyle: "italic",
              fontSize: isSmallScreen ? "12px" : "15px",
              lineHeight: "108%",
              letterSpacing: "0%",
              color: "#667085",
            }}
          >
            <span style={{ borderBottom: "1px solid #667085" }}>
              No members invited
            </span>
          </div>
        ))}
      {isSmallScreen ? (
        <BottomTray
          text={"Manage Members"}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        >
          <ManageMembers
            members={memberDetails}
            listId={listId}
            listName={listName}
            userId={userId}
            setMemberDetails={setMemberDetails}
          />
        </BottomTray>
      ) : (
        <UserDetailsModal
          show={isOpen}
          members={memberDetails}
          listId={listId}
          userId={userId}
          listName={listName}
          setMemberDetails={setMemberDetails}
          setShowModal={setIsOpen}
          rolesOptions={[
            { name: "commentor", label: "can view" },
            { name: "editor", label: "can edit" },
          ]}
        />
      )}
    </>
  );
};

export default InvitedMembersList;
